function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 12.75a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zm-.625-5v-5h1.25v5h-1.25zm0 2.5V9h1.25v1.25h-1.25z",
  fill: "#D1D5D9"
});

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none"
  }, props), _ref);
};

export default SvgExclamation;


//////////////////
// WEBPACK FOOTER
// ../svgs/Exclamation.svg
// module id = pM3A
// module chunks = 6